exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.excleConWrap .el-form-item__content{\n  margin:0 !important;\n}\n.excleConWrap .el-upload__tip{\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  margin: 0 !important;\n  float: right;\n  padding: 0 30px;\n}\n.excleConWrap .el-form-item{\n  margin: 0;\n}\n", ""]);

// exports
